import { MOCK_STUDENTS, MOCK_COURSES } from '../constants/mockData';

export const getStudentName = (id) => MOCK_STUDENTS.find(s => s.id === id)?.name || '未知学生';

export const getCourseName = (id) => MOCK_COURSES.find(c => c.id === id)?.name || '未知课程';

export const formatHours = (val) => {
  const num = Number(val || 0);
  return Number.isInteger(num) ? num.toString() : num.toFixed(1);
};
